<template>
  <div class="Serial">
    <div class="page-title">{{title}}</div>
    <div>
      <el-tabs 
        type="card" 
        v-model="active_tab"
      >
        <el-tab-pane label="할당현황" name="1">
          <SerialAssigned />
        </el-tab-pane>
        <el-tab-pane label="미할당현황" name="2">
          <SerialUnassigned
            v-if="active_tab === '2'"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import SerialAssigned from "./SerialAssigned";
import SerialUnassigned from "./SerialUnassigned";

export default {
  name: "Serial",
  components: {SerialAssigned, SerialUnassigned},
  data() {
    return {
      title: this.$t("title.serial"),
      active_tab: '1',
    }
  },
}
</script>